"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            width: '100%',
            height: '100%',
        },
        trigger: {
            width: '100%',
            height: '100%',
        },
        image: {
            width: '100%',
            height: '100%',
        },
        placeholder: {
            width: '100%',
            height: '100%',
        },
    });
});
